export default __webpack_public_path__ + "assets/media/favicon228.39faff3a42841bac93c1fa4d6bd35777.png";